module.exports = __webpack_public_path__ + "static/media/_Dashboard Sidebar Item Master (4).31197ed8.svg";